import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { isLoading } from '../../../store/shared/selectors-shared';
import { AppStore } from '../../../store/store';

@Component({
  selector: 'loading-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.css'
})
export class LoadingSpinnerComponent {

    isLoading$: Observable<boolean>;
  
    constructor(private store: Store<AppStore>
    ) {
      
      this.isLoading$ = this.store.select(isLoading);
    }
}
